export const ChatMessage = ({ message, index, streaming }) => (
  <div className={`readiness-chat-message ${message.role === "user" ? "is-user" : "is-guide"}`} data-testid={`readiness-chat-message-${index + 1}-${message.role}`}>
    <p className="mb-2 text-[10px] font-bold uppercase tracking-[0.2em] text-[#7a806f]" data-testid={`readiness-chat-message-${index + 1}-role`}>
      {message.role === "user" ? "You" : "TENET guide"}
    </p>
    <p className="whitespace-pre-wrap text-sm leading-7 text-[#33443e]" data-testid={`readiness-chat-message-${index + 1}-content`}>
      {message.role === "assistant" ? message.content.replaceAll("**", "") : message.content}
      {streaming && <span className="readiness-stream-cursor" aria-hidden="true" />}
    </p>
  </div>
);